import React, { useContext, useEffect, useState } from "react";
import "./AboutUs.css";
import { luxuryAboutUs } from "../../../utils/luxuryapis/Home/Homeapi";
import { Context } from "../../../utils/context";

function AboutUs() {
  const { IMG_URL } = useContext(Context);
  const [aboutus, setAboutus] = useState();

  const getAllLuxuryAboutUs = async () => {
    const res = await luxuryAboutUs();
    if (res?.success) {
      setAboutus(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryAboutUs();
  }, []);

  return (
    <>
      <section className="AboutUs">
        <div className="custom_container">
          {/* <div className="abouts_card_section">
            <div className="abouts_card_holder">
              <div className="row justify-content-between align-items-center ">
                <div className="col-xl-5 col-lg-6 col-md-6 order-md-1 order-2">
                  <div className="text_holder">
                    <h1>
                      Welcome to coinzkart.com a legacy of trust and innovation
                    </h1>
                    <p>
                      At CoinzKart, powered by Mittal Mudra LLP and part of the
                      prestigious Mittal Group since 1907, we blend heritage
                      with innovation to offer you an unmatched online
                      marketplace. Dive into a world where luxury meets
                      authenticity, with our handpicked selection of hallmarked
                      Gold, Silver, and other precious coins, alongside an array
                      of personal accessories, unique gift items, and artisanal
                      Copper-ware.
                    </p>
                  </div>
                </div>

                <div className="col-xl-5 col-lg-6 col-md-6 order-md-2 order-1">
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/in_company/aboutUs/img_1.png"
                      alt="about-us"
                      className="about_img"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="abouts_card_holder">
              <div className="row justify-content-between align-items-center  ">
                <div className="col-xl-5 col-lg-6 col-md-6 order-md-1 order-1">
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/in_company/aboutUs/img_2.png"
                      alt="about-us"
                      className="about_img"
                    />
                  </div>
                </div>

                <div className="col-xl-5 col-lg-6 col-md-6 order-md-2 order-2">
                  <div className="text_holder">
                    <p>
                      At CoinzKart, we are dedicated to providing a seamless,
                      secure, & enjoyable shopping experience. Our platform
                      offers a wide selection of premium products from trusted
                      sellers worldwide, ensuring that every item meets the
                      highest standards of quality and authenticity. We believe
                      in complete transparency, with pricing that is regularly
                      updated to reflect the latest market trends, so you can
                      shop with confidence. our mission is to make every
                      purchase safe, reliable, & satisfying, combining
                      authenticity, convenience, and fairness in one trusted
                      platform.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="abouts_card_holder">
              <div className="row justify-content-between align-items-center  ">
                <div className="col-xl-5 col-lg-6 col-md-6 order-md-1 order-2">
                  <div className="text_holder">
                    <h1>Why Choose Coinzkart?</h1>

                    <h4> Exclusive Selection:</h4>
                    <p>
                      From 999/995 purity Gold & 999 Silver coins to
                      custom-crafted gifts, find everything luxurious and
                      genuine.
                    </p>

                    <h4>Global Marketplace:</h4>
                    <p>
                      Buy & sell premium, hallmarked products with ease, from
                      any corner of the globe.
                    </p>

                    <h4>Personalization:</h4>
                    <p>
                      Make every gift unique with personalised and customised
                      options for every occasion.
                    </p>

                    <h4>Secure Shopping:</h4>
                    <p>
                      Enjoy peace of mind with 100% purchase guarantee, insured
                      shipping, and multiple secure payment options, including
                      Cash on Delivery in India (on most products).
                    </p>

                    <h4>Transparent Pricing:</h4>
                    <p>
                      Stay informed with frequently updated rates, ensuring you
                      always get the best value.
                    </p>
                  </div>
                </div>

                <div className="col-xl-5 col-lg-6 col-md-6 order-md-2 order-1">
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/in_company/aboutUs/img_3.png"
                      alt="about-us"
                      className="about_img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="abouts_card_section">
            {aboutus?.map((item, index) => (
              <div className="abouts_card_holder" key={item?.id}>
                <div className="row justify-content-between align-items-center">
                  {/* text column */}
                  <div
                    className={`col-xl-5 col-lg-6 col-md-6 ${
                      index % 2 === 0
                        ? "order-md-1 order-2"
                        : "order-md-2 order-2"
                    }`}
                  >
                    <div className="text_holder">
                      <h1>{item?.name}</h1>

                      <div
                        dangerouslySetInnerHTML={{
                          __html: item?.description,
                        }}
                      />
                    </div>
                  </div>

                  {/* image column */}
                  <div
                    className={`col-xl-5 col-lg-6 col-md-6 ${
                      index % 2 === 0
                        ? "order-md-2 order-1"
                        : "order-md-1 order-1"
                    }`}
                  >
                    <div className="img_holder">
                      <img
                        src={IMG_URL + item?.image}
                        alt={item?.name}
                        className="about_img"
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="banner_img_holder">
            <img
              src="/assest/luxury_images/in_company/aboutUs/banner.png"
              alt="about-us"
              className="about_img"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutUs;
